<template>
  <div class="">
    <div class="wpcm-recurring-btns">
      <ul class="d-inline-flex" v-if="show_recurring">
        <li
          class="m-0"
          v-if="strings"
          @click.prevent="setRecurring(true)"
        >
          <a href="#" :class="store.recurring && 'active'">{{ strings.recurring }}</a>
        </li>
        <li
          class="m-0"
          v-if="strings"
          @click.prevent="setRecurring(false)"
        >
          <a href="#" :class="!store.recurring && 'active'">{{ strings.one_time }}</a>
        </li>
      </ul>
    </div>
    <div class="wpcm-payment-gateways mt-3">
      <div class="mb-3">
        <ul class="wpcm-gateway-list" v-if="gateways">
          <li v-for="(gateway, gateway_id) in gateways" :key="gateway_id">
            <a
              @click.prevent="store.payment_method = gateway.id"
              :class="[(gateway.id === store.payment_method) && 'active']"
              title=""
              href="#"
            >
              <span v-if="gateway.icon"><img :src="gateway.icon" alt=""></span>
              {{ gateway.title ? gateway.title : gateway.name }}
            </a>
          </li>
        </ul>
      </div>

      <slot name="gateway_data"></slot>
      <slot name="billing_info"></slot>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../store';

const store = useDonationFormsStore();
const props = defineProps(["gateways", "show_recurring", "strings"]);

const setValue = (key, val) => {
  store[key] = val;
};

const setRecurring = (isRecurring: boolean) => {
  store.recurring = isRecurring;
  store.amount = 0; // Reset the amount
};

const getBack = () => {}

</script>